import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory as history } from 'react-router';
import moment from "moment";

import AssignmentIcon from '@material-ui/icons/Assignment';
import RedDownArrowIcon from '../../../../icons/RedDownArrowIcon';
import GreenUpArrowIcon from '../../../../icons/GreenUpArrowIcon';
import LoadingControl from '../../../../components/LoadingControl';
import DoughnutChart from '../../../../components/Graphs/DoughnutChart';
import DateRangePicker from '../../../../components/v3/DateRangePicker/DateRangePicker';
import SelectTable from '../../../../components/v3/CalibrationScreenV3/SelectTable';
import { dateFormat, dateTimeFormat, timePeriodicityOptions, colors } from '../../../../constants';
import { ZRole, SurveyType } from '../../../../generated';
import { isDefined, pageLoaded, arrayIsNotEmpty } from '../../../../utils';
import SuggestedAuditsSummaryTableForManager from './SuggestedAudits/SuggestedAuditsSummaryTableForManager';
import AgentsAuditsSummaryTableForManager from './AgentsAuditsSummaryTableForManager';
import QaCharts from './graphs/QaCharts';

import TicketsListModal from '../../../../components/v3/utils/Tickets/TicketsListModal';

import {
    loadQaDashboardManagerScreen,
    //loadQaSurveyCount,
    loadAllInteractions,
    loadCompletedAudits,
    loadProgressOverTimeStats,
    loadResponseBreakdown,
    loadAuditsReport,
    updateProps
} from '../QaDashboardScreenActions';
//import SuggestedAuditsModal from './SuggestedAudits/SuggestedAuditsModal';

class QaDashboardManagerScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showTicketsListPopup: false,
            showSelectQaSurveyFormPopup: false,
            selectedTimePeriodicityId: 1,

            //fromDate: moment().endOf('day').subtract(8, 'd').format(dateTimeFormat),
            //toDate: moment().endOf('day').format(dateTimeFormat),
            timezoneOffset: 0
        };

        this.closeTicketsListPopup = this.closeTicketsListPopup.bind(this);
        this.showTicketsListPopup = this.showTicketsListPopup.bind(this);

        this.showSelectQaSurveyFormPopup = this.showSelectQaSurveyFormPopup.bind(this);
        this.hideSelectQaSurveyFormPopup = this.hideSelectQaSurveyFormPopup.bind(this);

        this.onSelectNewTimeRange = this.onSelectNewTimeRange.bind(this);
        this.onSelectNewTimeRangeForTickets = this.onSelectNewTimeRangeForTickets.bind(this);

        this.onSelectNewTimePeriodicity = this.onSelectNewTimePeriodicity.bind(this);

        this.getAuditsReport = this.getAuditsReport.bind(this);

        this.getTimeRangesNode = this.getTimeRangesNode.bind(this);
        this.getSurveyCountSummaryNode = this.getSurveyCountSummaryNode.bind(this);
        this.goToAudit = this.goToAudit.bind(this);
    }

    componentDidMount() {
        pageLoaded('QA');
        const fromDate = moment().startOf('day').subtract(7, 'd').format(dateTimeFormat);
        const toDate = moment().endOf('day').format(dateTimeFormat);

        this.props.dispatch(updateProps({ fromDate: fromDate, toDate: toDate }));
        this.props.dispatch(loadQaDashboardManagerScreen(fromDate, toDate));
    }

    showTicketsListPopup() {
        this.setState({ showTicketsListPopup: true });
    }

    closeTicketsListPopup() {
        this.setState({ showTicketsListPopup: false });
    }

    onSelectNewTimeRangeForTickets(fromDate, toDate) {
        this.props.dispatch(updateProps({ fromDate: fromDate, toDate: toDate }));
        this.props.dispatch(updateProps({ allInteractions: undefined }));
        this.props.dispatch(loadAllInteractions(fromDate, toDate));
    }

    onSelectNewTimeRange(fromDate, toDate) {
        const
            {
                selectedQaSurveyform
            } = this.props;

        //this.setState({ fromDate: fromDate, toDate: toDate });
        this.props.dispatch(updateProps({ fromDate: fromDate, toDate: toDate }));

        //// wipe the old data
        this.props.dispatch(updateProps({
            qaSurveyCount: undefined,
            allInteractions: undefined,
            completedAudits: undefined,
            progressOverTimeStats: undefined,
            responseBreakdown: undefined,
        }));


        //// Get new data
        const surveyFormId = isDefined(selectedQaSurveyform) ? selectedQaSurveyform.id : -1;

        //this.props.dispatch(loadQaSurveyCount(fromDate, toDate));
        this.props.dispatch(loadAllInteractions(fromDate, toDate));

        this.props.dispatch(loadCompletedAudits(fromDate, toDate, surveyFormId));
        this.props.dispatch(loadProgressOverTimeStats(timePeriodicityOptions[0].id, fromDate, toDate, surveyFormId));
        //this.props.dispatch(loadResponseBreakdown(SurveyType.Agent, fromDate, toDate));
    }

    onSelectNewTimePeriodicity(selectedOption) {
        this.setState({ selectedTimePeriodicity: selectedOption.id });
    }

    showSelectQaSurveyFormPopup() {
        this.setState({ showSelectQaSurveyFormPopup: true });
    }

    hideSelectQaSurveyFormPopup(selectedSurveyForm) {
        const
            {
                qaSurveyforms,
                selectedQaSurveyform,
                fromDate,
                toDate
            } = this.props;

        this.setState({ showSelectQaSurveyFormPopup: false });

        if (arrayIsNotEmpty(selectedSurveyForm) && selectedQaSurveyform.id !== selectedSurveyForm[0].id) {
            const selected = qaSurveyforms.find(qa => qa.id == selectedSurveyForm[0].id);

            //// wipe the old data
            this.props.dispatch(updateProps({
                selectedQaSurveyform: selected,
                qaSurveyCount: undefined,
                completedAudits: undefined,
                progressOverTimeStats: undefined,
            }));


            //// Get new data
            //this.props.dispatch(loadQaSurveyCount(this.state.fromDate, this.state.toDate, selected.id));
            this.props.dispatch(loadCompletedAudits(fromDate, toDate, selected.id));
            this.props.dispatch(loadProgressOverTimeStats(timePeriodicityOptions[0].id, fromDate, toDate, selected.id));
        }
    }

    getSelectQaSurveyFormPopup() {
        const
            {
                qaSurveyforms,
            } = this.props;

        if (!qaSurveyforms)
            return;

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-qaForms">
                <SelectTable
                    title="Select a survey form:"
                    searchPlaceHolder="Search..."
                    options={qaSurveyforms}
                    onClose={this.hideSelectQaSurveyFormPopup} />
            </div>
        </div>);
    }

    getTimeRangesNode() {
        const {
            selectedQaSurveyform,
            fromDate,
            toDate
        } = this.props;

        const surveyName = selectedQaSurveyform ? selectedQaSurveyform.name : '';
        return (
            <div className="flex-container" style={{ margin: '24px 0' }}>
                <div className="title-secandary-400-12-14 cursor-pointer" onClick={this.showSelectQaSurveyFormPopup}>
                    <div className="title-primary-400-24-28" style={{ margin: '0 0 4px -5px' }}>
                        <AssignmentIcon style={{ margin: '0 3px -3px 0', color: colors.primary200 }} />
                        <span style={{ color: '#FF7700' }}>{surveyName}</span>
                    </div>
                    <div className="title-secandary-400-12-14">Select another Survey Form</div>
                </div>
                <div className="v3-button agent-view-interactions"
                    style={{ background: '#E6F7F8', padding: '13px 17px' }}
                    onClick={this.showTicketsListPopup}>
                    Find Tickets
                </div>
                <div className="flex-container-start">
                    <div style={{ margin: '0 0 0 20px' }}>
                        <DateRangePicker
                            fromDate={fromDate}
                            toDate={toDate}
                            onClose={this.onSelectNewTimeRange} />
                    </div>
                </div>
            </div>);
    }

    getSurveyCountSummaryNode() {
        const
            {
                allInteractionCount,
                allAgentCount,
                completedAudits,
                progressOverTimeStats,
                selectedQaSurveyform
            } = this.props;
        if (!isDefined(allInteractionCount) || !isDefined(allAgentCount) || !isDefined(completedAudits)) {
            return (<div className="system-dashboard-jibe-border SurveyCountSummery-main"
                style={{
                    marginRight: '16px', height: '327px', padding: '32px 24px',
                    backgroundImage: `url(${`../../../../../Assets/Images/V3Design/profileAgentNoAvatar.png`})`
                }}>
                <div className="flex-container" style={{ minHeight: '38px', margin: '0 0 15px 0', borderBottom: '1px solid #E6F7F8', }}>
                    <div className="title-primary-400-24-28">
                        QA Survey Count
                    </div>
                </div>
                <div style={{ minHeight: '94px' }}><LoadingControl /></div>
            </div>)
        }

        const auditedAgentCount = arrayIsNotEmpty(completedAudits) ? completedAudits.length : 0;
        const numberofAudits = arrayIsNotEmpty(completedAudits) ?
            completedAudits.map(i => i.qaSurveyCount).reduce((a, b) => a + b)
            : 0;

        //progressOverTimeStats
        //? parseInt(progressOverTimeStats.map(i => i.averageQaScore).reduce((a, b) => a + b) / progressOverTimeStats.length)
        //: 0;

        const auditedAgentsPercentage = parseFloat(100 * auditedAgentCount / allAgentCount).toFixed(2);
        const auditsPerAllTicketsPercentage = parseFloat(100 * numberofAudits / allInteractionCount).toFixed(2);

        const maxLengthInPixel = Math.max(auditedAgentsPercentage, auditsPerAllTicketsPercentage);

        const auditedAgentsPercentageLengthInPixel = parseInt(100 * auditedAgentsPercentage / maxLengthInPixel);
        const auditsPerAllTicketsPercentageLengthInPixel = parseInt(100 * auditsPerAllTicketsPercentage / maxLengthInPixel);

        let qaAverageScore = <div></div>;
        if (arrayIsNotEmpty(progressOverTimeStats) && isDefined(selectedQaSurveyform)) {
            const qaSurveyCountTotal =
                progressOverTimeStats.map(i => i.qaSurveyCount).reduce((a, b) => a + b);
            const sumOfAverageScoreForAllSurveys = progressOverTimeStats.map(i => i.surveysAverageScore * i.qaSurveyCount).reduce((a, b) => a + b);
            const averageQaScoreTotal = parseInt((sumOfAverageScoreForAllSurveys / qaSurveyCountTotal * 100) / selectedQaSurveyform.surveyFormMaxPoint);

            const percentsData = [
                {
                    name: '',
                    y: averageQaScoreTotal,
                    color: colors.fourth200
                },
                {
                    name: '',
                    y: 100 - averageQaScoreTotal,
                    color: '#E6F7F8'
                }
            ];

            const averageQaScoreTotalLabel = `${averageQaScoreTotal}%`;

            qaAverageScore = (<div style={{ marginRight: '27px' }}>
                <div key={'asat'} className="cal head-card">
                    <div className="cal head-card calibration-question-graph-height">
                        <DoughnutChart
                            propId={'asat'}
                            fontSize={18}
                            dataPoints={percentsData}
                            questionMetric={averageQaScoreTotalLabel}
                        />
                    </div>
                </div>
                <div className="flex-column-direction" style={{ marginTop: '9px' }}>
                    <div className="eighteen-regular-primary-color" style={{ marginBottom: '4px', marginLeft: '14px' }}>Avg QA Score</div>
                    {/*
                        <div className="H3_14 flex-container-justify-start-align-center">
                            <GreenUpArrowIcon />
                            <div>5%</div>
                            <div className="chart_stork flex-container-center">24 h</div>
                        </div>
                        */ }
                </div>
            </div>)
        }
        return (<div className="system-dashboard-jibe-border SurveyCountSummery-main"
            style={{
                marginRight: '16px', height: '327px', padding: '32px 24px',
                backgroundImage: `url(${`../../../../../Assets/Images/V3Design/profileAgentNoAvatar.png`})`
            }}>
            <div className="flex-container" style={{ minHeight: '38px', margin: '0 0 15px 0', borderBottom: '1px solid #E6F7F8', }}>
                <div className="title-primary-400-24-28">
                    QA Survey Count
                </div>
            </div>
            <div className="flex flex-space-between">
                <div style={{ marginLeft: '10px' }} >
                    <div className="h3-semibold" style={{ margin: '10px 0' }}>
                        Audited Agents: {auditedAgentCount}
                    </div>
                    <div key={1} style={{ marginBottom: '45px' }} className="flex-container-start">
                        <div className="SurveyCountSummery-bar" style={{ backgroundColor: colors.secandary200, width: `${auditedAgentsPercentageLengthInPixel}px` }}></div>
                        <div className="h3-semibold" style={{ marginRight: '10px' }} >
                            ({auditedAgentsPercentage}% of {allAgentCount} agents)
                        </div>
                    </div>

                    <div className="h3-semibold" style={{ margin: '10px 0' }}>
                        QA Survey Count: {numberofAudits}
                    </div>
                    <div key={2} className="flex-container-start">
                        <div className="SurveyCountSummery-bar" style={{ backgroundColor: colors.primary200, width: `${auditsPerAllTicketsPercentageLengthInPixel}px` }}></div>
                        <div className="h3-semibold" style={{ marginRight: '10px' }} >
                            ({auditsPerAllTicketsPercentage} % of {allInteractionCount} tickets)</div>
                    </div>
                </div>
                {qaAverageScore}

            </div>
        </div>)

    }

    goToAudit(audit) {
        history.push(`/QualityAssurance/status/audit/${audit.zacousticTicketId}`);
        this.props.dispatch(updateProps({ selectedSuggestedAudit: audit }));
    }


    getAuditsReport() {
        const
            {
                fromDate,
                toDate,
                selectedQaSurveyform
            } = this.props;

        this.props.dispatch(loadAuditsReport(selectedQaSurveyform.id, fromDate, toDate));
    }

    render() {
        const
            {
                allInteractions,
                allInteractionCount,
                currentUser,
                progressOverTimeStats,
                completedAudits,
                calibratedOnSurveyQuestions,
                fromDate,
                toDate
            } = this.props;

        if (!currentUser) {
            return <LoadingControl />;
        }
        if (currentUser.RoleId == ZRole.Agent) {
            return <LoadingControl />;
        }

        const timeRangesNode = this.getTimeRangesNode();
        const surveyCountSummaryNode = this.getSurveyCountSummaryNode();
        const selectQaSurveyFormPopup = this.state.showSelectQaSurveyFormPopup ? this.getSelectQaSurveyFormPopup() : undefined;

        return (
            <div className="main-page-width">
                {timeRangesNode}
                {selectQaSurveyFormPopup}
                {this.state.showTicketsListPopup &&
                    <TicketsListModal
                        fromDate={fromDate}
                        toDate={toDate}
                        calibratedOnSurveyQuestions={calibratedOnSurveyQuestions}
                        onSelectNewTimeRange={this.onSelectNewTimeRangeForTickets}
                        goToAudit={this.goToAudit}
                        isQaTickets={true}
                        allInteractions={allInteractions}
                        allInteractionCount={allInteractionCount}
                        onClose={this.closeTicketsListPopup} />}
                <div className="flex-container">
                    {surveyCountSummaryNode}
                    <SuggestedAuditsSummaryTableForManager />
                </div>
                <br />
                <QaCharts
                    fromDate={this.state.fromDate}
                    toDate={this.state.toDate}
                    selectedTimePeriodicity={this.state.selectedTimePeriodicityId}
                    progressOverTimeStats={progressOverTimeStats}
                    onSelectRfc={this.onSelectRfc}
                    onSelectChannel={this.onSelectChannel} />
                <br />

                <AgentsAuditsSummaryTableForManager
                    onDownloadReport={this.getAuditsReport}
                    interactionToShow={completedAudits} />
                <br />
                <br />
                <br />
            </div >);
    }
}

const select = state => ({ ...state.QaDashboardManagerScreen, ...state.session });

export default connect(select)(QaDashboardManagerScreen);